import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs';
import { Observable } from 'rxjs';
import {SavedHeaders} from '../property-list/property-list.models';
import {BE_API_AUTH_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {

  constructor(private http: HttpClient, private authService: AuthService) {}

  // Update to return Observable<SavedHeaders> instead of string[]
  getSavedHeaders(): Observable<SavedHeaders> {
    return this.http
      .get<SavedHeaders>(`${BE_API_AUTH_URL}/template/headers`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  saveHeaders(headers: SavedHeaders, options?: { suppressAudit?: boolean }) {
    return this.http
      .post(
        `${BE_API_AUTH_URL}/template/headers`,
        { ...headers, suppressAudit: options?.suppressAudit === true },
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
